import { Col, Descriptions, Row, Space, Table, Typography } from 'antd';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { WorkRecord } from '../../modules/work-records';
import Title from 'antd/lib/typography/Title';
import { styledTable } from '../styled/mixin';
import { maskingRrn2 } from '../../util/utils';

const StyledDiv = styled.div`
  ${styledTable}
  table {
    border-collapse: collapse;
  }

  tr {
    border: 1px solid;
  }

  .ant-descriptions-item-label {
    border: 1px solid;
  }
  .ant-descriptions-item-content {
    border: 1px solid;
  }
  .ant-table-cell {
    border: 1px solid;
  }
`;

interface WorkRecordPrintComponentProps {
  workRecord: WorkRecord;
  project: any;
}

const WorkRecordPrintComponent = forwardRef<
  HTMLInputElement,
  WorkRecordPrintComponentProps
>(({ workRecord, project }, ref) => {
  const { Text } = Typography;
  const getPageMargins = () => {
    return `@page { margin: 30px 30px 30px 30px !important; }`;
  };

  return (
    <StyledDiv ref={ref}>
      <style>{getPageMargins()}</style>
      <Row justify="center" style={{ marginBottom: '20px' }}>
        <Col>
          <span style={{ fontSize: '40px' }}>작업일보</span>
        </Col>
      </Row>
      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>현장명: {project.name}</Title>
        </Col>
        <Space>
          <Col style={{ marginRight: '10px' }}>
            <Title level={5}>작성자: {workRecord.createdBy.name}</Title>
          </Col>
          <Col>
            <Title level={5}>작성일자: {workRecord.createdDate}</Title>
          </Col>
        </Space>
      </Row>
      <Descriptions
        bordered
        layout="vertical"
        // column={1}
        size="small"
        style={{ marginBottom: '10px' }}
        title={null}
      >
        <Descriptions.Item
          label="금일진행사항"
          // style={{ whiteSpace: 'pre-wrap', width: '475px' }}
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {workRecord.todayNote}
        </Descriptions.Item>
        <Descriptions.Item
          label="명일예정사항"
          // style={{ whiteSpace: 'pre-wrap', width: '475px' }}
          style={{ whiteSpace: 'pre-wrap' }}
        >
          {workRecord.tomorrowNote}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        bordered
        // layout="vertical"
        size="small"
        style={{ marginBottom: '30px' }}
        title={null}
      >
        <Descriptions.Item
          label="특이사항"
          style={{ whiteSpace: 'pre-wrap' }}
          labelStyle={{ width: '100px' }}
        >
          {workRecord.issueNote ?? ' '}
        </Descriptions.Item>
      </Descriptions>
      <Row>
        <Col>
          <Title level={5}>외주공사 인력투입현황</Title>
        </Col>
      </Row>
      {workRecord.data.workers === undefined ||
      workRecord.data.workers.length === 0 ? (
        <Text>없음</Text>
      ) : (
        <Row>
          <Col flex={1}>
            <Table
              rowKey="id"
              columns={[
                {
                  title: '공정명',
                  dataIndex: 'gongjong',
                  width: '10%',
                },
                {
                  title: '업체명',
                  dataIndex: 'name',
                  width: '10%',
                },
                {
                  title: '직종',
                  dataIndex: 'jigjong',
                  width: '10%',
                },
                {
                  title: '인원수',
                  dataIndex: 'numOfWorkers',
                  width: '10%',
                  align: 'right',
                },
              ]}
              dataSource={workRecord.data.workers}
              pagination={false}
              summary={(pageData) => {
                let totalNumOfWorkers = 0;

                pageData.forEach(({ numOfWorkers }) => {
                  totalNumOfWorkers += numOfWorkers;
                });
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0}></Table.Summary.Cell>
                      <Table.Summary.Cell index={1}></Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        합계:
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="right">
                        {totalNumOfWorkers}
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </Col>
        </Row>
      )}

      <Row style={{ marginTop: '20px' }}>
        <Col>
          <Title level={5}>직영공사 출역현황</Title>
        </Col>
      </Row>
      {workRecord.data.directWorkers === undefined ||
      workRecord.data.directWorkers.length === 0 ? (
        <Text>없음</Text>
      ) : (
        <Row>
          <Col flex={1}>
            <Table
              rowKey="id"
              columns={[
                {
                  title: '이름',
                  width: '10%',
                  render: (value: any, record: any, index: any) =>
                    record.name.split('|')[0].trim(),
                },
                {
                  title: '주민번호',
                  width: '10%',
                  render: (value: any, record: any, index: any) =>
                    maskingRrn2(record.name.split('|')[1].trim()),
                },
                {
                  title: '공정명',
                  dataIndex: 'gongjong',
                  width: '10%',
                },
                {
                  title: '직종',
                  dataIndex: 'jigjong',
                  width: '10%',
                },
              ]}
              dataSource={workRecord.data.directWorkers}
              pagination={false}
            />
          </Col>
        </Row>
      )}
    </StyledDiv>
  );
});

export default WorkRecordPrintComponent;
